import { connect } from 'react-redux';
import { withTranslation } from '@piwikpro/ui-components';
import CampaignMediumParams from './CampaignMediumParams';

export type TagsInputValue = any[]

const mapStateToProps = (state, { t }) => {
  const campaignMediumParams: TagsInputValue = state.trackerSettings.app.settings
    .attributes.campaign_medium_params || [];
  const globalCampaignMediumParams: TagsInputValue = (
    state.trackerSettings.global.settings
      .attributes.campaign_medium_params || []
  )
    .map(
      element => ({
        value: element,
        disabled: true,
        tooltip: {
          content: t('apps.details.settings.globals.tooltip.content'),
        },
      }),
    );

  const globalAndAppTrackerSettings = [
    ...globalCampaignMediumParams,
    ...campaignMediumParams,
  ];

  return {
    globalAndAppTrackerSettings,
  };
};

export default withTranslation(['administration'])(connect(mapStateToProps, null)(CampaignMediumParams));
